<template>
  <div class="position-relative">
    <McChipList
      v-if="item?.box_types && item.box_types?.length"
      :items="item.box_types"
      :max-visible="3"
      itemTextField="name"
      showAllMode="dropdown"
      :showAllDropdownTitle="$t('setting.list.product.field.boxType')"
      showAllDropdownTrigger="action"
    />
    <span v-else>-</span>
  </div>
</template>

<script>
import McChipList from '@/components/McChipList'

export default {
  components: {
    McChipList,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
